function areArraysEqual(
  first: unknown[],
  second: unknown[],
  comparedObjects: WeakMap<object, object>
) {
  return (
    first.length === second.length &&
    first.every((value, index) =>
      areStructurallyEqual(value, second[index], comparedObjects)
    )
  )
}

function areObjectsEqual(
  first: Record<string, unknown>,
  second: Record<string, unknown>,
  comparedObjects: WeakMap<object, object>
) {
  const firstKeys = Object.keys(first)
  const secondKeys = Object.keys(second)

  return (
    firstKeys.length === secondKeys.length &&
    firstKeys.every(
      (key) =>
        Object.prototype.hasOwnProperty.call(second, key) &&
        areStructurallyEqual(first[key], second[key], comparedObjects)
    )
  )
}

export function areStructurallyEqual(
  first: unknown,
  second: unknown,
  comparedObjects = new WeakMap<object, object>()
): boolean {
  if (Object.is(first, second)) return true
  if (first === null || second === null) return false
  if (typeof first !== 'object' || typeof second !== 'object') return false

  if (first instanceof Date || second instanceof Date) {
    return (
      first instanceof Date &&
      second instanceof Date &&
      first.getTime() === second.getTime()
    )
  }

  const comparedSecond = comparedObjects.get(first)
  if (comparedSecond) return comparedSecond === second
  comparedObjects.set(first, second)

  if (Array.isArray(first) || Array.isArray(second)) {
    return (
      Array.isArray(first) &&
      Array.isArray(second) &&
      areArraysEqual(first, second, comparedObjects)
    )
  }

  return areObjectsEqual(
    first as Record<string, unknown>,
    second as Record<string, unknown>,
    comparedObjects
  )
}
